import { render } from "./Home.vue?vue&type=template&id=675deff2&scoped=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=675deff2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-675deff2"

export default script